import styled from 'styled-components/native';

const DialogBottomActions = styled.View`
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 80px;
  border-top-width: 1px;
  border-top-color: #d0d0d0;
  padding: 0 16px;
`;

export default DialogBottomActions;
